export default __webpack_public_path__ + "media/images/icons/eye-solid-8e7e265e4e0fd29748192667b1df6e79.svg";